var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"custom-class":"loading-box","visible":_vm.centerDialogVisible,"center":"","width":_vm.width,"show-close":false}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }